import React from 'react'
import './Page.scss'
import { Box } from '@mui/material'
export default function Page({ children }) {
  return (
    <Box className="card-content mt-4">
      <Box className="container-fluid">
        {children}
      </Box>
    </Box>
  )
}
